import { render, staticRenderFns } from "./galleryBox.vue?vue&type=template&id=717a4709&scoped=true"
import script from "./galleryBox.vue?vue&type=script&lang=js"
export * from "./galleryBox.vue?vue&type=script&lang=js"
import style0 from "./galleryBox.vue?vue&type=style&index=0&id=717a4709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a4709",
  null
  
)

export default component.exports